import { IOrganizationsDetail } from '@services';
import { createContext, useContext, useMemo, useState } from 'react';

interface IEnterpriseContext {
  organizationDetail: IOrganizationsDetail | undefined;
  setOrganizationDetail: React.Dispatch<React.SetStateAction<IOrganizationsDetail | undefined>>;
}

const EnterpriseContext = createContext<IEnterpriseContext>({
  organizationDetail: undefined,
  setOrganizationDetail: () => {},
});

export const EnterpriseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [organizationDetail, setOrganizationDetail] = useState<IOrganizationsDetail | undefined>(
    undefined,
  );

  const contextValue = useMemo(
    () => ({ organizationDetail, setOrganizationDetail }),
    [organizationDetail],
  );

  return <EnterpriseContext.Provider value={contextValue}>{children}</EnterpriseContext.Provider>;
};

export const useEnterpriseContext = (): IEnterpriseContext => {
  const ctx = useContext<IEnterpriseContext>(EnterpriseContext);

  if (ctx === undefined) {
    throw new Error('useEnterpriseContext must be used within a Provider');
  }

  return ctx;
};
